import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dimensions, View } from 'react-native';

import {
  INinjaEvent,
  useQueuedEventStore
} from '@ninjacart/nc-events-sdk-v2';
import {
  DiscoveryCardType,
  ICardActionData,
  IMetadata,
  KissanEventType,
  useProfileStore
} from '@ninjacart/nc-nk-store';
import { FlashList, ViewToken } from '@shopify/flash-list';
import { CattlePlayListCard } from './cattlePlayListCard';
import { CropsPlayListCard } from './cropsPlayListCard';
import { GovtSchemesPlayListCard } from './govtSchemesPlayListCard';
import { MachineryPlayListCard } from './machineryPlayListCard';
export const PlayListCard = ({
  horizontal,
  cardWidth,
  data,
}: {
  horizontal: boolean;
  cardWidth: number;
  data: IMetadata;
}) => {
  const [size, setSize] = useState(0.5);
  const [progress, setProgress] = useState(30);
  const screenWidth = Dimensions.get('window').width;
  const numColumns = horizontal ? undefined : Math.floor(screenWidth / cardWidth);
  const { t } = useTranslation();
  const [metadata, setMetaData] = useState<IMetadata>(data);
  const [dataItem, setItem] = useState<ICardActionData[]>(data.actionData);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const PlayListRenderItem = ({
    item,
    index,
  }: {
    item: ICardActionData | IMetadata | any;
    index: number;
  }) => {
    switch (metadata?.type) {
      case DiscoveryCardType.CROPS:
        return <CropsPlayListCard horizontal={horizontal} cardWidth={cardWidth} item={item} />;
      case DiscoveryCardType.MACHINERY:
        return <MachineryPlayListCard horizontal={horizontal} cardWidth={cardWidth} item={item} />;
      case DiscoveryCardType.GOVTSCHEMES:
        return (
          <GovtSchemesPlayListCard horizontal={horizontal} cardWidth={cardWidth} item={item} />
        );
      case DiscoveryCardType.ANIMALS:
        return <CattlePlayListCard cardWidth={cardWidth} item={item}  />;
      default:
        return null;
    }
  };

  const viewableItemsChanged = useCallback(({ viewableItems }: { viewableItems: ViewToken[] }) => {
    if (viewableItems[0]?.index !== undefined) {
      const activeIndex = viewableItems[0].index as number;
      if (activeIndex >= 3 && horizontal) {
        switch (metadata.type) {
          case DiscoveryCardType.CROPS:
          const horizontalVideosOnCropsEvent :INinjaEvent = {
            name: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_VIDEOSONCROPS,
            screenDetails: { screen: 'feed page' }
          };
          enqueue(horizontalVideosOnCropsEvent);
            break;
          case DiscoveryCardType.MACHINERY:
            const horizontalMachineryEvent :INinjaEvent = {
              name: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_MACHINERY,
              screenDetails: { screen: 'feed page' }
            };
            enqueue(horizontalMachineryEvent);
            break;
          case DiscoveryCardType.GOVTSCHEMES:
            const horizontalGovtSchemeEvent :INinjaEvent = {
              name: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_GOVT_SCHEME,
              screenDetails: { screen: 'feed page' }
            };
            enqueue(horizontalGovtSchemeEvent);
            break;
          case DiscoveryCardType.ANIMALS:

          const horizontalAnimalsEvent :INinjaEvent = {
            name: KissanEventType.FEEDPAGE_DIS_PAGESCROLL_HORIZONTAL_ANIMALS,
            screenDetails: { screen: 'feed page' }
          };
          enqueue(horizontalAnimalsEvent);
          default:
            break;
        }
      }
    }
  }, []);

  return (
    <View style={{ flex: 1 }}>
      <FlashList
        data={dataItem}
        renderItem={PlayListRenderItem}
        keyExtractor={(item, index) => {
          return index.toString();
        }}
        extraData={data.type}
        horizontal={horizontal}
        showsHorizontalScrollIndicator={false}
        estimatedItemSize={250}
        numColumns={numColumns}
        onViewableItemsChanged={viewableItemsChanged}
        onEndReachedThreshold={0.7}
      />
    </View>
  );
};
